// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"d86b3fd5","147":"bebbd366","228":"1ba1ce18","272":"8ec62dfe","287":"710f5bdd","352":"290ba542","549":"791931f4","666":"b2c655b9","816":"478b4069","837":"93ef7143","930":"2dadf3ab"}[chunkId] + ".chunk.js";
};